import { Widget } from "@opencx/widget-react";
import type React from "react";
import { useEffect } from "react";
import { env } from "../config/env";
import { useAuth } from "../context/AuthContext";
import { AI_WIDGET_OPEN_EVENT } from "../utils/aiWidget";

function openWidget(): void {
	// Check if OpenCX exposes a global API
	const win = window as Window & {
		openCXWidget?: { open: () => void };
		OpenCX?: { open: () => void };
		opencx?: { open: () => void };
	};

	if (win.openCXWidget?.open) {
		win.openCXWidget.open();
		return;
	}

	const iframe = document.querySelector(
		'iframe[title="OpenCX Live Chat Trigger"]',
	);

	if (iframe && iframe instanceof HTMLIFrameElement) {
		try {
			iframe.contentWindow?.postMessage({ type: "opencx:open" }, "*");
			iframe.contentWindow?.postMessage({ action: "open" }, "*");
			iframe.contentWindow?.postMessage("open", "*");
		} catch {
			// postMessage may fail in some contexts
		}

		iframe.scrollIntoView({ behavior: "smooth", block: "end" });

		const parent = iframe.parentElement;
		if (parent) {
			parent.style.animation = "pulse 1s ease-in-out 3";
			setTimeout(() => {
				parent.style.animation = "";
			}, 3000);
		}
	}
}

const AIAssistant: React.FC = () => {
	const { isAuthenticated } = useAuth();

	useEffect(() => {
		const handler = () => openWidget();
		window.addEventListener(AI_WIDGET_OPEN_EVENT, handler);
		return () => window.removeEventListener(AI_WIDGET_OPEN_EVENT, handler);
	}, []);

	// Show for all authenticated users (partners and admins)
	if (!isAuthenticated) {
		return null;
	}

	const widgetToken = env.WIDGET_TOKEN;
	if (!widgetToken) {
		return null;
	}

	return (
		<div
			style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 1000 }}
		>
			<Widget
				options={{
					token: widgetToken,
					initialMessages: [
						"Hey! I'm here to help you integrate with MoneyGram Ramps. What can I assist you with?",
					],
				}}
			/>
		</div>
	);
};

export default AIAssistant;
